import {
  SHOW_SPINNER,
  HIDE_SPINNER,
  TOAST_WARNING,
  TOAST_SUCCESS,
  TOAST_ERROR,
  SET_USER_INFO,
  SET_UPDATE_LOGGED_INFO,
} from './constants';

export const showSpinner = (payload = '') => ({ type: SHOW_SPINNER, payload });

export const hideSpinner = () => ({ type: HIDE_SPINNER });

export const toastWarning = (payload = '') => ({ type: TOAST_WARNING, payload });

export const toastSuccess = (payload = '') => ({ type: TOAST_SUCCESS, payload });

export const toastError = (payload = '') => ({ type: TOAST_ERROR, payload });

export const setUserInfo = (payload = {}) => ({ type: SET_USER_INFO, payload });
export const setLoggedInEmployeeInfo = (payload = {}) => ({ type: SET_UPDATE_LOGGED_INFO, payload });

export const customToast = (type: any, message: any) => (dispatch: any) => {
  let toast;
  switch (type) {
    case 1:
      toast = toastSuccess(message);
      break;
    case 2:
      toast = toastError(message);
      break;
    default:
      break;
  }
  dispatch(toast);
};

export const customSpinner = (type: any) => (dispatch: any) => {
  let toast;
  switch (type) {
    case 1:
      toast = showSpinner();
      break;
    case 2:
      toast = hideSpinner();
      break;
    default:
      break;
  }
  dispatch(toast);
};
